import React from 'react';
import {
  Container,
  Button,
} from '@uncinc/uncinc-react-kitchen-sink';
import i18next from '../../config/i18next';

import {
  HTTP_STATUS_PAGE_NOT_FOUND,
  HTTP_STATUS_PAGE_NO_ACCESS,
  HTTP_STATUS_SERVER_ERROR,
  HTTP_STATUS_SERVER_UNAVAILABLE,
} from '../../config/constants';


import './style.scss';

const NotFound = ({ status }) => {
  return (
    <div className="NotFound">
      <Container small className="NotFound__inner">
        {status === HTTP_STATUS_PAGE_NOT_FOUND && <h1>{i18next.t('HTTP_STATUS_PAGE_NOT_FOUND')}</h1>}
        {status === HTTP_STATUS_PAGE_NO_ACCESS && <h1>{i18next.t('HTTP_STATUS_PAGE_NO_ACCESS')}</h1>}
        {(status === HTTP_STATUS_SERVER_ERROR || status === HTTP_STATUS_SERVER_UNAVAILABLE) && <h1>{i18next.t('HTTP_STATUS_SERVER_ERROR')}</h1>}

        <Button className="Button--home" primary href="/">{i18next.t('home_button')}</Button>
      </Container>
    </div>
  );
};

export default NotFound;
